import { PayloadAction, createSelector } from '@reduxjs/toolkit';
import { initialState } from './utils';
import { RootState } from '../../../../store';
import { createExtendedSlice } from 'src/store/createExtendedSlice';
import { ReceiptsData, ReceiptsReducerState } from './types';
import { LogMsgFailed } from 'src/app/store/routingSlice/types';

const sliceName = 'receiptsView';

// =============================
// ------- Slice ----------
// =============================
const receiptsViewSlice = createExtendedSlice({
  name: sliceName,
  initialState,
  reducers: {
    // ---- Internal ---
    receiptsViewInit: (state) => {},
    receiptsViewOnFetchReceiptsRequest: (state) => {},
    receiptsViewOnFetchReceiptsSuccess: (
      state,
      { payload }: PayloadAction<ReceiptsData['suppliers']>,
    ) => {
      if (state.data) {
        state.data.suppliers = payload;
      } else {
        state.data = {
          suppliers: payload,
        };
      }
    },
    receiptsViewOnFetchReceiptsFailed: (
      state,
      { payload }: PayloadAction<LogMsgFailed>,
    ) => {},
    receiptsResetControlFilters: (state) => {
      state.filters.controls = initialState.filters.controls;
    },
    receiptsSetControlFilters: (
      state,
      { payload }: PayloadAction<ReceiptsReducerState['filters']['controls']>,
    ) => {
      state.filters.controls = payload;
    },
  },
});

// =============================
// ------- selectors ----------
// =============================
export const getReceiptsViewFilters = (state: RootState) =>
  state.receiptsView.filters;
export const getReceiptsViewData = (state: RootState) =>
  state.receiptsView.data;

export const getReceiptsViewIsWithReceiptsIntegration = (state: RootState) =>
  false;
export const getReceiptsViewIsWithReceiptsData = (state: RootState) => true;

export const getReceiptsViewFiltersData = createSelector(
  getReceiptsViewFilters,
  (filters) => filters.controls,
);
export const getReceiptsViewReceiptsData = createSelector(
  getReceiptsViewData,
  (data) => data?.suppliers ?? null,
);

// =============================
// ------- Exports ----------
// =============================

export const {
  receiptsViewInit,
  receiptsViewOnFetchReceiptsRequest,
  receiptsViewOnFetchReceiptsSuccess,
  receiptsViewOnFetchReceiptsFailed,
  receiptsResetControlFilters,
  receiptsSetControlFilters,
} = receiptsViewSlice.actions;

export default receiptsViewSlice.reducer;
